export var ErrorCode;
(function (ErrorCode) {
    ErrorCode[ErrorCode["InvalidFileType"] = 0] = "InvalidFileType";
    ErrorCode[ErrorCode["FileSizeMaximumExceeded"] = 1] = "FileSizeMaximumExceeded";
    ErrorCode[ErrorCode["FileSizeMinimumNotMet"] = 2] = "FileSizeMinimumNotMet";
    ErrorCode[ErrorCode["FileCountExceeded"] = 3] = "FileCountExceeded";
})(ErrorCode || (ErrorCode = {}));
export const errorCodeNames = {
    [ErrorCode.InvalidFileType]: "invalid file type",
    [ErrorCode.FileCountExceeded]: "file count exceeded",
    [ErrorCode.FileSizeMinimumNotMet]: "min file size not met",
    [ErrorCode.FileSizeMaximumExceeded]: "max file size exceeded",
};
export class FileDropError extends Error {
    constructor(code, file, message) {
        super(message);
        this.code = code;
        this.message = message;
        this.file = file;
        this.name = errorCodeNames[code];
    }
}
export class InvalidFileTypeError extends FileDropError {
    constructor(file, allowed, message) {
        if (!message) {
            message = `${file.name} is not an accepted file type (${file.type}`;
        }
        super(ErrorCode.InvalidFileType, file, message);
        if (typeof allowed === "string") {
            allowed = allowed.split(",");
        }
        this.allowed = allowed;
    }
}
export class FileSizeMinimumNotMetError extends FileDropError {
    constructor(file, minimum, message) {
        message =
            message !== null && message !== void 0 ? message : `$file size ${file.size} does not meet the file size minimum of ${minimum}.`;
        super(ErrorCode.FileSizeMinimumNotMet, file, message);
        this.minimum = minimum;
    }
}
export class FileSizeLimitExceededError extends FileDropError {
    constructor(file, limit, message) {
        message = message !== null && message !== void 0 ? message : `file size ${file.size} exceeds file size limit of ${limit}.`;
        super(ErrorCode.FileSizeMinimumNotMet, file, message);
    }
}
export class FileCountExceededError extends FileDropError {
    constructor(file, limit, message) {
        message = message !== null && message !== void 0 ? message : `file count limit of ${limit} exceeded`;
        super(ErrorCode.FileCountExceeded, file, message);
        this.limit = limit;
    }
}
